export enum TicketStatus {
	Open = 'open',
	Answered = 'answered',
	Closed = 'closed',
}

export type SupportTab = 'recent' | 'last15days' | 'answered';

export interface TicketMessage {
	_id: string;
	user: string;
	content: string;
	fromMe?: boolean;
	createdAt?: Date;
	updatedAt?: Date;
}

export interface SupportTicketDTO {
	_id: string;
	user: string;
	subject: string;
	messages: TicketMessage[];
	status: TicketStatus;
	createdAt?: Date;
	updatedAt?: Date;
}

export interface CreateTicketPayload {
	subject: string;
	message: string;
}

export interface AddMessagePayload {
	ticketId: string;
	message: string;
}

export interface AdminTicketUser {
	_id: string;
	name: string;
	avatar?: { url: string } | null;
}

export interface AdminSupportTicketDTO extends Omit<SupportTicketDTO, 'user'> {
	user: AdminTicketUser;
}

export interface FindAllTicketsResponse {
	docs: SupportTicketDTO[];
	totalDocs: number;
	totalPages: number;
	page: number;
	limit: number;
}

export interface FindAllAdminTicketsResponse {
	docs: AdminSupportTicketDTO[];
	totalDocs: number;
	totalPages: number;
	page: number;
	limit: number;
}
